import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  CssBaseline,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  LinearProgress,
  Paper,
  ListItem,
  ListItemAvatar,
  ListItemText,
  List,
  Chip,
  DialogContentText,
  Divider,
  FormControl,
  TextField,
  Select,
  MenuItem
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IconBook, IconBuildings, IconCheck, IconCircle, IconCircleCheck, IconCreditCard, IconCreditCardFilled, IconCreditCardPay, IconDots, IconFileInvoice, IconHandMove, IconHeadphones, IconLink, IconPhone, IconPlus, IconPointFilled, IconRecordMail, IconRocket, IconSlash, IconStar, IconTargetArrow, IconTrash, IconUnlink, IconX } from "@tabler/icons-react";
import { BeatLoader } from "react-spinners";
import EditIcon from "@mui/icons-material/Edit";
// import NoData from '.././Images/nodta'
import NoData from ".././Images/background.png";
import PageContainer from "./Pagecontainer";
import ScheduleDemo from "./demo";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import Cookies from 'js-cookie';
const Dashboard = () => {
  // const colors = [
  //   "#F5FAFD", // lighter blue
  //   "#F4FDF0", // lighter green
  //   "#FFF6ED", // lighter orange
  //   "#F4F4FB", // lighter purple
  //   "#EDF9F9", // lighter teal
  //   "#FFFDEB", // lighter yellow
  //   "#FDF3F3", // lighter pink/red
  //   "#F1F6F0", // lighter olive
  //   "#FFF1EC", // lighter coral
  //   "#F3F2FF", // lighter indigo
  // ];
  const colors = [
    '#f5f7fa',"#e0f6ff63", "#fff5d8a1","#b6e15e2b",'#f9dee45c','#e0edfbc4',
  ]

  const [projects, setProjects] = useState([]);
  const [Deletepopup, setDeletepopup] = useState(false);
  const [loader, setloader] = useState(false);
  const [ProjectId, setProjectid] = useState("");
  const [setupdata,setsetupdata]=useState()
  const [successpopup, setsuccesspopup] = useState(false)
  const [open, setopen] = useState(false)
  const navigate = useNavigate();
  const [scheduledDateTime, setScheduledDateTime] = useState(dayjs())
  const [selectedZone, setSelectedZone] = useState("Asia/Kolkata");
  const [Success, setSuccess] = useState(false)
  const { register, handleSubmit, reset, formState: { errors }, trigger, setValue } = useForm();

// const userInfo = JSON.parse(Cookies.get('user-info'))
const userInfo = JSON.parse(Cookies.get("user-info") || "null");
//const initialEmailRef = useRef(null);

 // useEffect(() => {
   // const initialUserInfo = Cookies.get('user-info');
   // if (initialUserInfo) {
      //const parsed = JSON.parse(initialUserInfo);
      //initialEmailRef.current = parsed.email;
    //}

   // const interval = setInterval(() => {
      //const cookieData = Cookies.get('user-info');
     // if (cookieData) {
       // try {
          //const current = JSON.parse(cookieData);
         // if (current.email !== initialEmailRef.current) {
            //console.log('Email changed. Reloading page...');
            //window.location.reload();
          //}
        //} catch (err) {
          //console.error('Invalid cookie format', err);
      //  }
    //  }
  //  }); 
//
  //  return () => clearInterval(interval); 
//  }, []);

const scheduleDemoRef = useRef();
  const getProjects = async () => {
    try {
      setloader(true);
      const response = await axios.get("/apiV1/projects/");
      console.log(response.data);
      if (response.status === 200) {
        setProjects(response.data);
        getSetupData()
        setloader(false);
      }
    } catch (error) {
      console.log(error);
      setloader(false);
    }
  };
  const handleDelete = async () => {
    setDeletepopup(false);
    setloader(true);
    try {
      const response = await axios.delete(`/apiV1/projects/${ProjectId}/`);
      if (response.status === 204) {
        getProjects();
        setloader(false);
        setsuccesspopup(true);
      }
    } catch (err) {
      console.error(err);
      setloader(false);
      setDeletepopup(false);
    }
  };

  const timeZones = [
    {
      value: "Asia/Kolkata",
      label: "Asia/Kolkata",
      offset: "GMT+5:30"
    },
    {
      value: "America/New_York",
      label: "America/New_York",
      offset: "GMT-5:00"
    },
    {
      value: "Europe/London",
      label: "Europe/London",
      offset: "GMT+0:00"
    },
    {
      value: "Asia/Tokyo",
      label: "Asia/Tokyo",
      offset: "GMT+9:00"
    }
    // add more as needed
  ];
  const GetData = async () => {
          try {
              const response = await axios.get('/apiV1/get-profile/');
              if (response.status === 200) {
                  console.log(response.data.message);
                  setValue('email', response?.data?.message?.email)
                  setValue('mobile', response?.data?.message?.mobile)
                  setValue('companyName', response?.data?.message?.company_name)
                  setValue('name', response?.data?.message?.fullname)
                  setValue("companywebsite",response?.data?.message?.company_website)
              }
          } catch (error) {
              console.error("Error fetching profile data:", error.response ? error.response.data : error.message);
          }
      };
  useEffect(() => {
    GetData();
  }, [])
  const getSetupData = async () => {
    try {
      setloader(true);
      const response = await axios.get('/apiV1/set-up/')
      if (response.status === 200) {
        setsetupdata(response.data)
        setloader(false);
      }
    }
    catch (err) {
      console.log(err?.response?.data?.message);
      setloader(false);
    }
  }
  useEffect(() => {
    getProjects();
  }, []);
  const onSubmit = async (data) => {
    setloader(true)
    try {
      const config2 = {
        headers: {
          Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
        },
      };
      let req =
      {
        ticket_desc: "I would like to schedule a demo of your software solution to understand its features and capabilities.",
        user_email: data.email,
        employee_number: userInfo?.id,
        user_name: data.name,
        company_name: data.companyName,
        id: userInfo?.id,
        demo_shedule_date: scheduledDateTime,
        demo_shedule_time_zone: selectedZone,
        is_demo_ticket: 1
      }
      const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/create_ticket/`, req, config2)
      if (response.status === 201) {
        setopen(false)
        setloader(false)
        setSuccess(true)
      }
    } catch (err) {
      setloader(false)
      console.log(err);
    }
  };
  const handleChangetime = (event) => {
    setScheduledDateTime(event.target.value);
  };
  const handleZoneChange = (event) => {
    setSelectedZone(event.target.value);
  };
  const [minDateTime, setMinDateTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    setMinDateTime(localISOTime);
  }, []);
  const cards = [
    {
      id:1,
      title: 'Company Setup',
      description: 'Add your company logo, name, website, and basic information to personalize your documents.',
      status: setupdata?.is_cmp_added=== true? "Completed":"Pending",
      statusColor: setupdata?.is_cmp_added=== true? "green":"#F97316",
      bgColor: '#9aa8db',
      path:"/myprofile?is_edit=true&tab=1",
      icon: (
        <IconBuildings
          sx={{
            color: setupdata?.is_cmp_added === true ? "green" : "#F97316",
          }}
        />
      ),
      
    },
    {
      id:3,
      title: 'Billing & Address',
      description: 'Set up your billing information and company address for invoices and legal documents.',
      status: setupdata?.is_billing_added=== true? "Completed":"Pending",
      statusColor: setupdata?.is_billing_added=== true? "green":"#F97316",
      bgColor: '#d57474',
      path:"/myprofile?is_edit=true&tab=2",
      icon: (
        <IconCreditCardFilled
          sx={{
            color: setupdata?.is_billing_added === true ? "green" : "#F97316",
          }}
        />
      ),
    },
    // {
    //   title: 'Quick Tutorial',
    //   description: 'Take a quick tour to learn how to create your first business document and use key features.',
    //   status: 'Available',
    //   statusColor: '#22C55E', // green
    //   bgColor: '#5ebb7e', // light green
    //   icon: <IconBook sx={{ color: '#22C55E' }} />,
    // },
   {
    id: 4,
    title: setupdata?.is_subscribed === true ? 'Buy More Credits' : 'Upgrade Plan',
    description: setupdata?.is_subscribed === true 
      ? 'Top up your credits to continue generating reports seamlessly.' 
      : 'Unlock premium templates, advanced features, and unlimited projects with our Pro plan.',
    status: setupdata?.is_subscribed === true ? "Buy More" : "Trial: Free Access Active",
    statusColor: setupdata?.is_subscribed === true ? "green" : "#F97316",
    bgColor:'orange', 
    path: "/plans",
    icon: <IconStar />,
    
  }

  ];
  const progressItems = [
    { text: 'Account created and verified', completed: true },
    { text: 'Company information added', completed: setupdata?.is_cmp_added },
    { text: 'Billing details configured', completed: setupdata?.is_billing_added },
    { text: 'First project created', completed: false },
    // { text: 'Tutorial completed', completed: false },
  ];

  const totalFlags = 4;
  const completedFlags = [setupdata?.is_billing_added, setupdata?.is_cmp_added,setupdata?.is_subscribed].filter(Boolean).length;
  const status = (completedFlags / totalFlags) * 100;

  return (
    <>
      <PageContainer title="SmartInvestorDeck | Dashboard">



        <ScheduleDemo showBanner={true} ref={scheduleDemoRef} />



        <Box sx={{ display: "flex" }}>
          <Box component="main" sx={{ flexGrow: 1 }}>
            {setupdata?.is_subscribed === false || setupdata?.is_guest? <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: '#f99292',
                p: 1,
                borderRadius: 2,
                mb:1
                // boxShadow: 1,
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <IconStar color="#FFF" fontSize="small" />
                <Typography variant="subtitle2" fontWeight="bold" color="#fff">
                  Free Trial Active
                </Typography>
                <Typography variant="body2" color="#fff" ml={1}>
                You’re Exploring On A Free Trial! Upgrade To Unlock All Business Features And Exclusive Investor Decks.
                </Typography>
              </Box>
              <Button
                size="small"
                className="setupbtn"
                sx={{ padding: "2px 7px" }}
                onClick={() => navigate("/plans")}
              >
                Upgrade Now
              </Button>
            </Box> : ""}
            {loader ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  width: "100vw",
                  position: "fixed",
                  top: 0,
                  left: 0,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <BeatLoader color=" #07659c" size={20} />
              </Box>
            ) : projects.length === 0 ? (
              <>
                <Box sx={{ textAlign: 'center', p: 3, maxWidth: '100%' }}>
                  {/* Header */}
                  <Box textAlign="center" mb={4}>
                    <Typography variant="h4" fontWeight={600} color="text.primary" mb={1}>
                      Welcome to Smart Investor Deck!
                    </Typography>
                    {setupdata?.is_password_added ? 
                    <><Typography color="text.secondary">
                      Let's get your account set up you can start creating amazing business documents.
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<IconPlus />}
                      sx={{ mt: 2, }}
                      onClick={() => navigate("/create")}
                    >
                      Create your first Project
                    </Button></>: 
                    <><Typography color="text.secondary">
                      Set your password to get started with creating amazing business documents.
                    </Typography><Button
                      variant="contained"
                      startIcon={<IconPlus />}
                      sx={{ mt: 2, }}
                      onClick={() => navigate("/myprofile?is_edit=true&tab=3")}
                    >
                      Setup Password
                    </Button></>}
                  </Box>

                  {/* Progress Bar */}
                  <Box mb={4}>
                    <LinearProgress
                      variant="determinate"
                      value={status}
                      sx={{
                        height: 8,
                        borderRadius: 5,
                        backgroundColor: '#ffcdd2', // light red background
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: '#f44336' // red progress bar
                        }
                      }}

                    />
                  </Box>

                  {/* Cards */}
                  <Grid container spacing={6} >
                    {cards.map((card, index) => (
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4} >
                        <Card
                          onClick={() => navigate(card.path)}
                          variant="outlined"
                          sx={{
                            cursor: 'pointer',
                            transition: 'box-shadow 0.3s',
                            '&:hover': { boxShadow: 3 },
                            borderRadius: 5,
                            border: "none",
                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                            mb: 4,
                            mt:1
                            // box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
                          }}
                        >
                          <CardContent sx={{ gap: 2 }}>
                            <Box display="flex" gap={2} textAlign={"center"} alignItems="center">
                            <Avatar
                              sx={{
                                bgcolor: card.bgColor,
                                width: 48,
                                height: 48,
                                flexShrink: 0,
                                mb: 2,
                              }}
                            >
                              {card.icon}
                            </Avatar>
                            <Typography variant="h6" fontWeight={600} gutterBottom color="#2b2c2a">
                                {card.title}
                              </Typography>
                            </Box>
                            <Box textAlign="left">
                              
                              <Typography  color="text.secondary" mb={1} sx={{ fontSize: 15 }}>
                                {card.description}
                              </Typography>
                              <Chip
                                label={card.status}
                                icon={
                                  <IconPointFilled
                                    fontSize="small"
                                    style={{ color: '#fff' }} 
                                  />
                                }
                                size="small"
                                sx={{
                                  backgroundColor: card.statusColor, 
                                  color: '#fff',                    
                                  fontWeight: 500,
                                }}
                              />


                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>

                  {/* Action Buttons */}
                  <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    gap={2}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <Button
                      variant="contained"
                      color="error"
                      disabled
                      startIcon={<IconRocket />}
                      sx={{cursor:"default"}}
                      className="setupbtn"
                    >
                      Start Setup Process
                    </Button>
                    <Button className="setupbtn" onClick={() => navigate("/create")}>
                      Skip for Now
                    </Button>
                    <Button className="setupbtn" startIcon={<IconPhone />} onClick={() =>setopen(true)}>
                      Contact Support
                    </Button>
                  </Box>
                </Box>
                <Paper
                  sx={{
                    maxWidth: 700,
                    margin: '32px auto',
                    borderRadius: 2,
                    border: '1px solid #f0f0f0',
                  }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Box
                      display="flex"
                      alignItems="center"
                      mb={1}
                    >
                      <IconTargetArrow color="#249ee7" size={30} />
                      <Typography
                        variant="h6"
                        sx={{
                          marginLeft: 2,
                          fontSize: 18,
                          fontWeight: 600,
                          color: '#333',
                          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                        }}
                      >
                        Your Setup Progress
                      </Typography>
                    </Box>

                    <List disablePadding>
                      {progressItems.map((item, index) => (
                        <ListItem
                          key={index}
                          sx={{
                            borderBottom: index < progressItems.length - 1 ? '1px solid #f5f5f5' : 'none',
                            paddingLeft:"0"
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              sx={{
                                bgcolor: item.completed ? '#4caf50' : 'transparent',
                                width: 24,
                                height: 24,
                              }}
                              variant="circular"
                            >
                              {item.completed ? (
                                <IconCircleCheck />
                              ) : (
                                <IconCircle color="#c9c2c2" size={30} />
                              )}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: 15,
                                  color: item.completed ? '#008000' : '#666',
                                  fontWeight: item.completed ? 700 : 500,
                                  lineHeight: 1.4,
                                }}
                              >
                                {item.text}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Paper></>
            ) : (
              <>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 500,
                      maxWidth: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "0px 0px",
                      fontSize: "28px",
                      marginBottom: "20px",
                    }}
                    title="Static Business Name"
                  >
                    Welcome to Smart Investor Deck, {userInfo.fullname}

                  </Typography>
                </Box>


                <Grid>




                  <Grid container spacing={3}>
                    {/* Static Card */}
                    <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                      <Card
                        sx={{
                          maxWidth: 480,
                          minHeight: 202,
                          maxHeight: 345,
                          borderRadius: 2,
                          boxShadow: 2,
                          "&:hover": {
                            boxShadow: 4,
                            transform: "scale(1.01)",
                          },
                          overflow: "hidden",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >

                        <CardContent
                          sx={{
                            padding: 3,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                            background:"#fff",
                              // "linear-gradient(135deg, #01467105 0%, #01467108 100%)",
                            border: "2px solid #d5d5d5",
                            borderRadius: "10px",
                            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.08)",
                            position: "relative",
                            overflow: "hidden",
                            transition: "all 0.3s ease",
                            minHeight: "201px",
                            "&:hover": {
                              transform: "translateY(-1px)",
                              // boxShadow: "0 12px 20px rgba(0, 0, 0, 0.12)",
                              "& .plus-icon": {
                                backgroundColor: "#66a321",
                                transform: "scale(1.1)",
                              },
                            },
                            // "&::before": {
                            //   content: '""',
                            //   position: "absolute",
                            //   bottom: 0,
                            //   left: 0,
                            //   right: 0,
                            //   height: "4px",
                            //   background:
                            //     "",
                            // },
                          }}
                          onClick={() => navigate("/create")}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              position: "relative",
                              zIndex: 1,
                            }}
                          >
                            <Box
                              className="plus-icon"
                              sx={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                backgroundColor: "#014671",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: 2,
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                transition: "all 0.3s ease",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "#ffffff",
                                  fontSize: "36px",
                                  fontWeight: 400,
                                  lineHeight: 1,
                                }}
                              >
                                +
                              </Typography>
                            </Box>

                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 600,
                                maxWidth: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: " #014671",
                                fontSize: "20px",
                              }}
                              title="New Project"
                            >
                              New Project
                            </Typography>

                            <Typography
                              variant="body2"
                              sx={{
                                color: "#616161",
                                mt: 0.5,
                                textAlign: "center",
                              }}
                            >
                              Start building something amazing
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              position: "absolute",
                              top: -20,
                              right: -20,
                              width: "100px",
                              height: "100px",
                              backgroundColor: "#26262666",
                              opacity: 0.1,
                              borderRadius: "50%",
                              transform: "rotate(45deg)",
                              zIndex: 0,
                            }}
                          />
                        </CardContent>
                      </Card>
                    </Grid>

                    {/* Dynamic Project Cards */}
                    {projects.map((project, index) => (
                      <Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={index}>
                        <Card
                          sx={{
                            maxWidth: 480,
                            minHeight: 200,
                            maxHeight: 345,
                            borderRadius: 2,
                            boxShadow: 0,
                            backgroundColor: colors[index % colors.length],
                            // boxShadow: "0px 0px 8px 0px #efebeb",
                            border: " 1px solid #ededed !important",
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                              boxShadow: "0px 0px 15px 0px #efebeb",
                              transform: "scale(1.01)",
                            },
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <CardContent
                            sx={{
                              padding: 3,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "start",
                                width: "100%",
                              }}
                            >
                              <Box>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    fontWeight: 500,
                                    maxWidth: "100%",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: " 200px",
                                  }}
                                  title={project.business_name}
                                >
                                  <Box sx={{ position: "relative", display: "inline-block" }}>
                                    <Avatar
                                      src={project.logo_url || ""}
                                      alt={project.business_name}
                                      sx={{
                                        width: 55,
                                        height: 55,
                                        cursor: "pointer",
                                        border: "2px solid #e0e0e0",
                                      }}
                                      // onClick={() => {
                                      //   navigate('/create', {
                                      //     state: {
                                      //       projectId: project.id,
                                      //       projectName: project.business_name,
                                      //       mode: 'edit',
                                      //       logo: project.logo_pic
                                      //     }
                                      //   });
                                      // }}
                                    >
                                      {!project.logo_pic && project.business_name?.[0]?.toUpperCase()}
                                    </Avatar>

                                   
                                  </Box>

                                  <Box
                                    sx={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      flexShrink: 1, 
                                      minWidth: 0, 
                                    }}
                                  >
                                    {project.business_name}
                                  </Box>
                                </Typography>

                                {project.url && (


                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      mt: 1,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                      maxWidth: "100%",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: " 195px",
                                    }}
                                    title={project.url}
                                  >
                                    <IconLink
                                      sx={{
                                        mt: 0.5,
                                        fontSize: "20px",
                                        color: "#000",
                                      }}
                                    />
                                    <span
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {project.url}
                                    </span>
                                  </Typography>
                                )}
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  gap: 1, 
                                  alignItems: 'center', 
                                }}
                              >
                                {/* Pencil/Edit Icon */}
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    navigate('/create', {
                                      state: {
                                        projectId: project.id,
                                        // projectName: project.business_name,
                                        mode: 'edit',
                                        // logo: project.logo_pic,
                                      },
                                    });
                                  }}
                                >
                                  <EditIcon fontSize="small" sx={{ color: '#28639eff', fontSize: 18 }} />
                                </IconButton>

                                {/* Trash Icon */}
                                <IconButton
                                  color="error"
                                  onClick={() => {
                                    setDeletepopup(true);
                                    setProjectid(project.id);
                                  }}
                                >
                                  <IconTrash />
                                </IconButton>
                              </Box>
                            </Box>
                          </CardContent>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: 2,
                              gap: 1,
                            }}
                          >
                            <Box>
                              <Typography>
                                Language: {project.language}
                              </Typography>
                            </Box>
                            <Button
                              variant="outlined"
                              size="sm"
                              sx={{
                                backgroundColor: "#e7e5e5",
                                color: "#000",
                                maxWidth: "70px",
                                border: "1px solid #e7e5e5",
                                borderRadius: "5px",
                                fontSize: "14px",
                              }}
                              onClick={() =>
                                navigate(
                                  `/documents?id=${project.id}&name=${project.business_name}`
                                )
                              }
                            >
                              View
                            </Button>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>

                
                </Grid>
              </>
            )}
          </Box>
        </Box>

        <Dialog
          open={Deletepopup}
          onClose={() => setDeletepopup(false)}
          aria-labelledby="confirm-delete-dialog-title"
          aria-describedby="confirm-delete-dialog-description"
          PaperProps={{
            sx: { borderRadius: "16px", padding: "16px" },
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box />
            <IconButton size="small" onClick={() => setDeletepopup(false)}>
              <IconX />
            </IconButton>
          </Box>
          <DialogTitle
            id="confirm-delete-dialog-title"
            align="center"
            sx={{ marginTop: -3 }}
          >
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "#fdecea",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  marginBottom: 2,
                }}
              >
                <IconTrash size={32} color="#e57373" />
              </Box>
            </Box>
            <Typography variant="h6" fontWeight="bold">
              Confirm Delete
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography id="confirm-delete-dialog-description" align="center">
              Are you sure you want to delete Project? This action cannot be
              undone.
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              marginBottom: 1,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              sx={{
                width: 120,
                borderColor: "#e0e0e0",
              }}
              onClick={() => setDeletepopup(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{ width: 120, backgroundColor: "#c63037", border: "none" }}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </PageContainer>
      <Dialog open={successpopup} fullWidth maxWidth="md"sx={{ textAlign: "center", maxWidth: "700px", margin: "auto" }}>
          <DialogTitle sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#0e860e",
                  padding: 3,
                  "&:hover": { backgroundColor: "#0e860e" }
                }}
              >
                <IconCheck color="#fff" size={30} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              Your project has been Deleted successfully!
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { setsuccesspopup(false); }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      <Dialog open={open} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" fontWeight="bold">
              Schedule a Demo
            </Typography>
            <IconButton onClick={() => { setopen(false); reset() }}><IconX /></IconButton>
          </Box>
        </DialogTitle>
        <Divider />

        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Grid container spacing={2}>
              {/* Name */}
              <Grid item xs={6}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Full Name <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                  <TextField
                    placeholder="Enter Name"
                    {...register("name", {
                      required: "Full Name is required",
                      validate: value =>
                        value.trimStart() === value || "Full Name should not start with a space",
                      pattern: {
                        value: /^[a-zA-Z\s]+$/,
                        message: "Full Name should contain only letters and spaces",
                      },
                    })}
                    error={!!errors.name}
                    helperText={errors.name?.message}
                    onKeyUp={() => trigger("name")}
                    disabled={loader}
                  />
                </FormControl>
              </Grid>

              {/* Email */}
              <Grid item xs={6}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Email <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                  <TextField
                    type="email"
                    fullWidth
                    variant="outlined"
                    disabled
                    {...register('email', {
                      required: 'Email is required',
                      pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: 'Invalid email address',
                      },
                    })}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                  />
                </FormControl>
              </Grid>

              {/* Company */}
              <Grid item xs={6}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Company Name <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                  <TextField
                    placeholder='Enter Company Name'
                    fullWidth
                    variant="outlined"
                    {...register('companyName', {
                      required: "Company Name is Required"
                    })}
                    error={!!errors.companyName}
                    helperText={errors.companyName?.message}
                    onKeyUp={() => trigger("companyName")}
                  />
                </FormControl>

              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Company Website</Typography>
                  <TextField
                    placeholder="Enter Website Name"
                    fullWidth
                    variant="outlined"
                    {...register('companywebsite', {
                      pattern: {
                        value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/,
                        message: "Invalid URL address",
                      },
                    })}
                    error={!!errors.companywebsite}
                    helperText={errors.companywebsite?.message}
                    onKeyUp={() => trigger("companywebsite")}
                  />
                </FormControl>
              </Grid>

              {/* Phone */}
              <Grid item xs={6}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Mobile <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                  {/* <TextField
                                                placeholder="Enter Mobile"
                                                {...register("mobile", {
                                                    required: "Mobile Number is required",
                                                    pattern: {
                                                        value: /^[0-9]+$/,
                                                        message: "Only numeric values are allowed",
                                                    },
                                                    minLength: {
                                                        value: 10,
                                                        message: "Mobile number must be at least 10 digits",
                                                    },
                                                    maxLength: {
                                                        value: 12,
                                                        message: "Mobile number must not exceed 12 digits",
                                                    },
                                                })}
                                                error={!!errors.mobile}
                                                helperText={errors.mobile?.message}
                                                onKeyUp={() => trigger("mobile")}
                                                disabled={loader}
                                                inputProps={{
                                                    maxLength: 12,
                                                }}
                                            /> */}
                  <TextField
                    placeholder="Enter Mobile"
                    {...register("mobile", {
                      required: "Mobile Number is required",
                      pattern: {
                        value: /^(?! )[+0-9()\-\s]{8,20}$/,
                        message: "Enter a valid number (no space at start, allow +()- and digits)",
                      },
                      minLength: {
                        value: 8,
                        message: "Mobile number must be at least 8 characters",
                      },
                      maxLength: {
                        value: 20,
                        message: "Mobile number must not exceed 20 characters",
                      },
                    })}
                    error={!!errors.mobile}
                    helperText={errors.mobile?.message}
                    onKeyUp={() => trigger("mobile")}
                    disabled={loader}
                    inputProps={{
                      maxLength: 20,
                      inputMode: "tel",
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Schedule Date & Time <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                  <TextField
                    id="birthdaytime"
                    name="birthdaytime"
                    type="datetime-local"
                    // label="Schedule Date & Time"
                    value={scheduledDateTime}
                    onChange={handleChangetime}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: minDateTime,
                    }}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Select Time Zone <span style={{ color: "red", fontSize: "15px" }}>*</span>
                </Typography>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Select
                    labelId="timezone-label"
                    id="timezone"
                    value={selectedZone}
                    onChange={handleZoneChange}
                    required
                    sx={{
                      height: "2.6rem",
                      "& .MuiSelect-select": {
                        height: "1rem",
                        display: "flex",
                        alignItems: "center"
                      }
                    }}
                  >
                    {timeZones.map((zone) => (
                      <MenuItem key={zone.value} value={zone.value}>
                        {`${zone.offset} ${zone.label} (${zone.offset})`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>


            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => { setopen(false); reset() }} variant="outlined" disabled={loader}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" className='button2' disabled={loader}>
              {loader ? <BeatLoader color='#fff' /> : "Request a Demo"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog
        open={Success}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setSuccess(false);
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xs"
        sx={{ textAlign: "center" }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
          Success
        </DialogTitle>

        <Divider />

        <DialogContent>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <IconButton
              disableRipple
              sx={{
                backgroundColor: "#0e860e",
                padding: 3,
                "&:hover": { backgroundColor: "#0e860e" }
              }}
            >
              <IconCheck color="#fff" size={30} />
            </IconButton>
          </Box>

          <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
            Your demo has been scheduled successfully. Our team will reach out soon with further details
          </DialogContentText>
        </DialogContent>

        <Divider />

        <DialogActions>
          <Button
            onClick={() => { setSuccess(false) }}
            sx={{
              olor: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              borderRadius: "8px",
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
        
    </>
  );
};

export default Dashboard;
